module.exports = __webpack_public_path__ + "img/form_desktop.54fb3c79.svg";